import { ChangeDetectionStrategy, Component, Injector, forwardRef } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { BfxRequestPriceModel } from "app/bfx-interface-controls/models/bfx-interface-controls.models";
import { RateSpinnerComponent } from "shared/base-components/rate-spinner.component";
import { CcyPairPromiseLookupService } from "shared/cubiq-services";
import { BfxFieldNumberDirective } from "../../shared/base-components/bfx-field-number";
import { BfxInputDirective } from "../../shared/base-components/bfx-input";
import {
  NUMBER_SPINNER_INPUTS,
  NUMBER_SPINNER_VIEW_PROVIDERS,
} from "../../shared/base-components/number-spinner.component";

export const SPINNER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BfxPriceSpinnerComponent),
  multi: true,
};

@Component({
  selector: "bfx-price-spinner",
  templateUrl: "../../shared/base-components/html/number-spinner.html",
  providers: [SPINNER_VALUE_ACCESSOR],
  viewProviders: NUMBER_SPINNER_VIEW_PROVIDERS,
  inputs: NUMBER_SPINNER_INPUTS,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BfxPriceSpinnerComponent extends RateSpinnerComponent {
  constructor(
    injector: Injector,
    inputDirective: BfxInputDirective,
    fieldDirective: BfxFieldNumberDirective,
    currencyPairService: CcyPairPromiseLookupService,
  ) {
    super(injector, inputDirective, fieldDirective, currencyPairService);
  }
  protected override getModelValue(): any {
    return new BfxRequestPriceModel(this.data.value, this.data.textValue);
  }
}
